import { createRoot } from 'react-dom/client'

import IndexPage from './IndexPage'

import {
  I18n,
  XLang,
} from 'konekti-ex-functions'
import lc from './Components/Lang/ja'
import en2ja from './Components/Lang/dict'

I18n.putVocabularies(lc)
I18n.setLanguage('ja')
XLang.init(en2ja)

createRoot(document.getElementById('root')!).render(
  <IndexPage />,
)
